import Button from 'Components/Atoms/ButtonDeprecated/Button';
import ContainerHeader from 'Components/Atoms/Containers/ContainerHeader/ContainerHeader';
import Paper from 'Components/Atoms/Containers/Paper/Paper';
import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import TextItem from 'Components/Atoms/ExpandableItems/TextItem';
import TextItemInfo from 'Components/Atoms/ExpandableItems/TextItemInfo';
import TextItemLabel from 'Components/Atoms/ExpandableItems/TextItemLabel';
import RowItem from 'Components/Atoms/Row/RowItem';
import RowItemInfo from 'Components/Atoms/Row/RowItemInfo';
import RowItemTitle from 'Components/Atoms/Row/RowItemTitle';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { patchEntity } from 'Store/Settings/Entities/Actions';
import { EntityId } from 'Store/Settings/Entities/PropTypes';
import { getEntityIds, getEntitiesById, getEntityById, getEntityRelationById } from 'Store/Settings/Entities/Selectors';

const EntityRelationSettings = ({
    id,
    entities, entityById,
    relations,
    ...props
}: EntityRelationSettingsProps) => {
    const prepareEntities = (v) => v.filter(i => i != id)
        .map((i, idx) => ({
            id: i,
            isActive: false,
            isEditable: false,
            order: idx
        }));

    const [state, setState] = useState({
        isEdit: false,
        hasRelation: relations?.some(e => e.isActive == true)
    });

    const [data, setData] = useState<any>({
        entities: relations || prepareEntities(entities),
        activeEntities: relations?.filter(i => i.isActive) || []
    });

    useEffect(() => {
        if (!state.isEdit) return;
        if (data.activeEntities.length == 0) {
            setData({
                ...data,
                entities: relations || entities.filter(i => i != id)
                .map((i, idx) => ({
                    id: i,
                    isActive: false,
                    isEditable: false,
                    order: idx
                })) 
            })
        }
    }, [state.isEdit]);

    useEffect(() => {
        setData({
            entities: relations,
            activeEntities: relations?.filter(i => i.isActive) || []
        })
    }, [relations]);

    const handleCancel = () => setData({
        ...data,
        entities: relations || prepareEntities(entities)
    })

    const handleChange = (id, key, value) => {
        const newArray = [...data.entities].map(obj => obj.id == id
            ? ({
                ...obj,
                [key]: value
            })
            : obj
        );

        setData({
            ...data,
            entities: newArray
        });
    }

    const handleMove = (item, direction) => {
        const entities = [...data.entities];
        const originalOrder = item.order;
        const newOrder = originalOrder + direction;

        const adjacentItem = entities.find(i => i.order == newOrder);
        const newArray = entities.map(obj => ({
            ...obj,
            order: (obj.id == item.id)
                ? newOrder
                : (obj.id == adjacentItem.id)
                ? originalOrder
                : obj.order
        }));

        setData({
            ...data,
            entities: newArray
        });
    }

    const handleSave = () => {
        props.patchEntity(id, {
            relations: data.entities
        });
    };
    

    return <>
        <ContainerHeader title='Relatie'>
            <EditButtons
                onEdit={(value) => setState({...state, isEdit: value})}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        </ContainerHeader>
        { !state.isEdit && data.activeEntities?.length == 0
            ? <div>Deze entiteit heeft geen relaties</div>
            : <Paper>
                {
                    (state.isEdit
                    ? [...(data?.entities || [])]
                    : [...(data?.activeEntities || [])]
                    ).sort((a, b) => a.order - b.order).map(item => <RowItem>
                        <RowItemTitle>{ EntityHelper.getDisplayValueByName(entityById?.[item.id]?.name) }</RowItemTitle>
                        <RowItemInfo>
                            <div style={{display: 'inline-flex'}}>
                                <TextItem hasBorder>
                                    <TextItemLabel>Is gerelateerd?: </TextItemLabel>
                                    <TextItemInfo>
                                        <Field
                                            isEdit={state.isEdit}
                                            value={item.isActive}
                                            type={FieldType.Toggle}
                                            onChange={(value) => handleChange(item.id, 'isActive', value)}
                                        />
                                    </TextItemInfo>
                                </TextItem>
                                <TextItem>
                                    <TextItemLabel>Is bewerkbaar?: </TextItemLabel>
                                    <TextItemInfo>
                                        <Field
                                            isEdit={state.isEdit}
                                            value={item.isEditable}
                                            type={FieldType.Toggle}
                                            onChange={(value) => handleChange(item.id, 'isEditable', value)}
                                        />
                                    </TextItemInfo>
                                </TextItem>
                                {
                                    state.isEdit &&
                                    <TextItem>
                                        <TextItemLabel>Order: </TextItemLabel>
                                        <TextItemInfo>
                                        {/* <ButtonGroup>
                                            {
                                                item.order < Math.max(...data.entities.map(o => o.order)) &&
                                                <Button
                                                    style={{borderRadius: '100%'}}
                                                    appearance="subtle"
                                                    iconBefore={<ArrowDownIcon primaryColor={'#36B37E'} label="edit" size="medium"/>}
                                                    onClick={() => handleMove(item, 1)}
                                                />
                                            }
                                            {
                                                item.order > 0 &&
                                                <Button
                                                    style={{borderRadius: '100%'}}
                                                    appearance="subtle"
                                                    iconBefore={<ArrowUpIcon primaryColor={'#36B37E'} label="edit" size="medium"/>}
                                                    onClick={() => handleMove(item, -1)}
                                                />
                                            }
                                        </ButtonGroup> */}
                                        </TextItemInfo>
                                    </TextItem>
                                }
                            </div>
                        </RowItemInfo>
                    </RowItem>)
                }
            </Paper>
        }
    </>;
}

interface Props {
    id: EntityId
}

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityById(state, props.id),
    entities: getEntityIds(state),
    entityById: getEntitiesById(state),
    relations: getEntityRelationById(state, props.id)
})

const mapDispatch = {
    patchEntity    
}

type EntityRelationSettingsProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityRelationSettings);